import { createHttpClient } from "./http";

class DemandaRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	getAuthHeader() {
		const token = localStorage.getItem("access_token");
		return { Authorization: `Bearer ${token}` };
	}

	async save(data) {
		return this.axios.post("demanda-distribuidor", data, {
			headers: this.getAuthHeader(),
		});
	}

	async update(data) {
		return this.axios.put("demanda-distribuidor", data, {
			headers: this.getAuthHeader(),
		});
	}

	async getDemandasPorData(unidadeDistribuidoraId, data, page = 1, limit = 50) {
		return this.axios.get("demanda-distribuidor/por-data", {
			params: { unidadeDistribuidoraId, data, page, limit },
			headers: this.getAuthHeader(),
		});
	}

	async getCobertura(unidadeDistribuidoraId, data) {
		return this.axios.get("demanda-distribuidor/cobertura", {
			params: { unidadeDistribuidoraId, data },
			headers: this.getAuthHeader(),
		});
	}

	async getById(id) {
		return this.axios.get(`demanda-distribuidor/${id}`, {
			headers: this.getAuthHeader(),
		});
	}

	async changeVisibility(id) {
		return this.axios.put(`demanda-distribuidor/${id}/change-visibility`, {}, {
			headers: this.getAuthHeader(),
		});
	}
}

export default DemandaRepository;
